import React, { Component, PropTypes } from 'react'

import ImageWithLoader from 'components/ImageWithLoader'
import "./InstanceView.css"
import ZoomOutImg from 'images/icon-zoom-out.png'
import ZoomInImg from 'images/icon-zoom-in.png'
import LeftArrowImg from 'images/arrow_left.png'
import RightArrowImg from 'images/arrow_right.png'
import { trackedClickEvent } from '../util/analytics';

class InstanceView extends Component { 

  render() {
    const { views, selected, onSelectView, isViewZoomIn, toggleViewZoom} = this.props;
    const mainImg = views.filter((v) => v.name === selected)[0];
    let prevImg = "";
    let nextImg = "";
    if(mainImg.name === "FS")
    {
      prevImg = "PP";
      nextImg = "BC";
    }
    else if(mainImg.name === "BC")
    {
      prevImg = "FS";
      nextImg = "PP";
    }
    else if(mainImg.name === "PP")
    {
      prevImg = "BC";
      nextImg = "FS";
    }
    return (
      <div className='instance-view'>
        <div className="instance-view-header">
          <div className="previews">
            {
              views.map((v) => {
                return (v.src !== '')
                  ? <img key={v.name} alt={`Preview of ${v.name}`} src={v.src}
                    className={'hidden preview' + ((v.name === selected) ? ' selected' : '')}
                    onClick={trackedClickEvent("Switch Image: " + v.name, () => onSelectView(v.name))} />
                  : ''
              })
            }
            <img alt={`Zoom`} src={isViewZoomIn ? ZoomOutImg : ZoomInImg }
              className={'zoom-in-img'}
              onClick={toggleViewZoom} />
          </div>
        </div>
        { mainImg && mainImg.src && 
          <div className="instance-img">
            <div className="img-arrow-container left">
              <img className="img-arrow" 
                alt={`Previous`}
                src={LeftArrowImg}
                onClick={() => onSelectView(prevImg)} />
            </div>
            <ImageWithLoader className={"main img-responsive " + (isViewZoomIn ? "zoomed-img" : "unzoomed-img")}
              alt={`Main Product View ${mainImg.name}`} 
              src={mainImg.src+(isViewZoomIn ? "&wid=1120" : "&wid=800")} /> 
            <div className="img-arrow-container right">
              <img className="img-arrow"
                alt={`Next`} 
                src={RightArrowImg}
                onClick={() => onSelectView(nextImg)} />
            </div>
          </div>
        }
      </div>
    );
  }
}

InstanceView.propTypes = {
  views: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  selected: PropTypes.string.isRequired,
  onSelectView: PropTypes.func.isRequired, 
  isViewZoomIn: PropTypes.bool.isRequired,
  toggleViewZoom: PropTypes.func.isRequired,
}

export default InstanceView